import React from 'react';
import './BannerGrid.css';

const BannerGrid = ({ banners }) => {
  return (
    <div className="banner-grid-vertical">
      {banners.map((banner, index) => (
        <a href={banner.link} className="banner-grid-vertical__item" key={index}>
          <img src={banner.image} alt={`Banner ${index + 1}`} loading="lazy" />
        </a>
      ))}
    </div>
  );
};

export default BannerGrid;
